<style lang="scss">
    .form__form-group {
        margin-bottom: 1rem;
        width: 100%;
        display: block;
    }
</style>

<script lang="ts" context="module">
    export type CheckboxOptionType = { name: string; value: string };
    let counter = 0;
</script>

<script lang="ts">
    import { _ } from 'svelte-i18n';
    import type { Validator } from '@eqs/cms-svelte-irtools';
    import { combineValidators } from '@eqs/cms-svelte-irtools';
    import { CheckboxInputSvelte } from '@eqs/cms-svelte-irtools';

    type DlObject = {
        name: string;
        value: string;
        parent: string;
    };

    const generalOptions: Array<DlObject> = [
        {
            name: $_('dropdown_options.publication.adhoc_news'),
            value: 'ad-hoc-news',
            parent: ''
        },
        {
            name: $_('dropdown_options.publication.corporate_news'),
            value: 'corporate-news',
            parent: ''
        }
    ];

    export let checkboxGroup: string[] = [];
    export let error: string | null = null;
    export let validators: Validator[] = [];
    export const validate = async () => {
        try {
            await combineValidators(...validators)('', checkboxGroup);
            error = null;
        } catch (e: unknown) {
            const errorObject = e as Error;
            error = errorObject.message || 'Unknown error';
            throw e;
        }
    };

    const removeChildDLs = (selectedDLs: string[], dls: Array<DlObject>) => {
        return selectedDLs
            .map((dlname) => {
                return dls.filter((dl) => dl.value === dlname).pop();
            })
            .filter((dl) => !selectedDLs.includes(dl?.parent))
            .map((dl) => dl.value);
    };

    $: {
        checkboxGroup = removeChildDLs(checkboxGroup, [...generalOptions]);
    }
</script>

<div class="publicationBlock">
    <div class="publication-block">
        {$_('contact_form.labels.publication_text')}
        {#each generalOptions as general}
            <CheckboxInputSvelte
                bind:bindGroup="{checkboxGroup}"
                label="{general.name}"
                value="{general.value}"
                disabled="{checkboxGroup.includes(general.parent)}"
            />
        {/each}
    </div>
    <div class="row">
        <div class="col-sm-12">
            {#if error}
                <p class="error">{error}</p>
            {/if}
        </div>
    </div>
</div>
